import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { EnrichedUser } from 'getstream';
import { ActivityData } from '../models/SocialFeed';
import { UserSocialProfile } from '../models/SocialProfile';

interface BlockedUsersState {
	blockedUserIds: string[];
	blockUser: (userId: string) => void;
	unblockUser: (userId: string) => void;
}

const useBlockedUsersStore = create<BlockedUsersState>()(
	persist(
		(set, get) => ({
			blockedUserIds: [] as string[],
			blockUser: (userId: string) => {
				const { blockedUserIds } = get();
				if (!blockedUserIds.includes(userId)) {
					set({ blockedUserIds: [...blockedUserIds, userId] });
				}
			},
			unblockUser: (userId: string) => {
				set({ blockedUserIds: get().blockedUserIds.filter((id) => id !== userId) });
			}
		}),
		{
			name: 'blockedUserIds'
		}
	)
);

export default useBlockedUsersStore;

export const useActivitiesWithoutBlockedUsers = (activities: ActivityData[]): ActivityData[] => {
	const blockedUserIds = useBlockedUsersStore((state) => state.blockedUserIds);
	return activities.filter((activity) => {
		const profile = (activity.actor as unknown as EnrichedUser)?.data as unknown as UserSocialProfile;
		return profile?.userId ? !blockedUserIds.includes(profile.userId) : true;
	});
};
